import {
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Table,
    TableBody
} from '@material-ui/core';
import formatters from '../../../Core/Grid/inputFormatter';
import { AddCircleOutlined } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';

const summaryHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "newVol",
        label: "New Vol",
        classLabel: "columnSize80"
    },
    {
        label: "New Profit",
        id: "newProfit",
        classLabel: "columnSize80"
    },
    {
        label: "Avg.New PPU",
        id: "avgNewPPU",
        classLabel: "columnSize80"
    },
    {
        id: "newPPS",
        label: "New PPS",
        classLabel: "columnSize80"
    },
    {
        id: "usedVol",
        label: "Used Vol",
        classLabel: "columnSize80"
    },
    {
        id: "usedProfit",
        label: "Used Profit",
        classLabel: "columnSize80"
    },
    {
        id: "avgUsedPPU",
        label: "Avg.Used PPU",
        classLabel: "columnSize80"
    },
    {
        id: "usedPPS",
        label: "Used PPS",
        classLabel: "columnSize80"
    }
];

const newHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "newVol",
        label: "Total Vol",
        classLabel: "columnSize80"
    },
    {
        id: "newRetail",
        label: "Retail",
        classLabel: "columnSize80"
    },
    {
        id: "newMotability",
        label: "Motability",
        classLabel: "columnSize80"
    },
    {
        id: "newFleet",
        label: "Fleet",
        classLabel: "columnSize80"
    },
    {
        id: "avgNewPPU",
        label: "Avg.Retail PPU",
        classLabel: "columnSize80"
    },
    {
        id: "newFinance",
        label: "Retail Fin Vol",
        classLabel: "columnSize80"
    },
    {
        id: "newFinancePercent",
        label: "Finance Pen",
        classLabel: "columnSize80"
    },
    {
        id: "newFinanceCommission",
        label: "Finance Commission",
        classLabel: "columnSize80"
    }
];

const usedHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "usedVol",
        label: "Total Vol",
        classLabel: "columnSize80"
    },
    {
        id: "usedRetail",
        label: "Retail",
        classLabel: "columnSize80"
    },
    {
        id: "avgUsedPPU",
        label: "Avg.Retail PPU",
        classLabel: "columnSize80"
    },
    {
        id: "usedMechPrep",
        label: "Mech Prep",
        classLabel: "columnSize80"
    },
    {
        id: "usedBodyWork",
        label: "Bodywork",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinance",
        label: "Retail Fin Vol",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinancePercent",
        label: "Finance Pen",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinanceCommission",
        label: "Finance Commission",
        classLabel: "columnSize80"
    },
    {
        id: "usedTrade",
        label: "Trade",
        classLabel: "columnSize80"
    },
    {
        id: "usedTradePPU",
        label: "Trade PPU",
        classLabel: "columnSize80"
    },
];

const newProductsHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "newPPS",
        label: "PPS",
        classLabel: "columnSize80"
    },
    {
        id: "newProductProfit",
        label: "Product Profit",
        classLabel: "columnSize80"
    },
    {
        id: "newProductPen",
        label: "Product Pen",
        classLabel: "columnSize80"
    },
    {
        id: "newSupagard",
        label: "Supagard",
        classLabel: "columnSize80"
    },
    {
        id: "newServicePlan",
        label: "Service Plan",
        classLabel: "columnSize80"
    },
    {
        id: "newTyreAndAlloy",
        label: "Tyre and Alloy",
        classLabel: "columnSize80"
    },
    {
        id: "newCosmetic",
        label: "Cosmetic",
        classLabel: "columnSize80"
    },
];

const usedProductsHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "usedPPS",
        label: "PPS",
        classLabel: "columnSize80"
    },
    {
        id: "usedProductProfit",
        label: "Product Profit",
        classLabel: "columnSize80"
    },
    {
        id: "usedProductPen",
        label: "Product Pen",
        classLabel: "columnSize80"
    },
    {
        id: "usedSupagard",
        label: "Supagard",
        classLabel: "columnSize80"
    },
    {
        id: "usedServicePlan",
        label: "Service Plan",
        classLabel: "columnSize80"
    },
    {
        id: "usedTyreAndAlloy",
        label: "Tyre and Alloy",
        classLabel: "columnSize80"
    },
    {
        id: "usedCosmetic",
        label: "Cosmetic",
        classLabel: "columnSize80"
    },
];

const financeHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize80"
    },
    {
        id: "newFinance",
        label: "Cases(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newFinancePercent",
        label: "Retail Pen(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newFinanceVol",
        label: "Total Volume(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newFinanceCommission",
        label: "Commission(N)",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinance",
        label: "Cases(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinancePercent",
        label: "Retail Pen(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinanceVol",
        label: "Total Volume(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedFinanceCommission",
        label: "Commission(U)",
        classLabel: "columnSize80"
    }
];

const warrantyHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "warrantyVol",
        label: "Volume",
        classLabel: "columnSize80"
    },
    {
        id: "warrantyProfit",
        label: "Warranty Profit",
        classLabel: "columnSize80"
    },
    {
        id: "warrantyPen",
        label: "Warrant Pen",
        classLabel: "columnSize80"
    },
    {
        id: "ccPremium",
        label: "CC Premium",
        classLabel: "columnSize80"
    },
    {
        id: "ccPremiumPlus",
        label: "CC Premium +",
        classLabel: "columnSize80"
    },
    {
        id: "nicEx",
        label: "NIC Extended",
        classLabel: "columnSize80"
    },
    {
        id: "missedUpsell",
        label: "Missed Upsell",
        classLabel: "columnSize80"
    }
];

const othersHeaders = [
    {
        id: "site",
        label: "Site",
        classLabel: "columnSize180"
    },
    {
        id: "newAccProfit",
        label: "Acc. Profit(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newDeliveryPack",
        label: "Delivery Pack(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newIncorrectAdmin",
        label: "Incorrect Admin(N)",
        classLabel: "columnSize80"
    },
    {
        id: "newIncorrectFuel",
        label: "Incorrect Fuel(N)",
        classLabel: "columnSize80"
    },
    {
        id: "usedAccProfit",
        label: "Acc. Profit(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedDeliveryPack",
        label: "Delivery Pack(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedIncorrectAdmin",
        label: "Incorrect Admin(U)",
        classLabel: "columnSize80"
    },
    {
        id: "usedIncorrectFuel",
        label: "Incorrect Fuel(U)",
        classLabel: "columnSize80"
    },
    {
        id: "tradeIncorrectAdmin",
        label: "Incorrect Admin(T)",
        classLabel: "columnSize80"
    },
];

const handleFinanceModal = (e, site) => {
    e.currentTarget.classList.toggle('active');
    e.currentTarget.parentElement.classList.toggle('openModal');

    document.getElementById("financeModal-"+site).classList.toggle("financeModelOpen");
}

export const GroupSalesPerformanceTable = (props) => {
    const sites = props.sites;
    const type = props.type;

    return (
        <TableContainer className='groupComparisonTable'>
            <Table>
                <TableHead>
                    <TableRow>
                        {
                            type === "Summary" ? 
                                summaryHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            : 
                            type === "New" ? 
                                newHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            : 
                            type === "Used" ? 
                                usedHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "NewProducts" ? 
                                newProductsHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "UsedProducts" ? 
                                usedProductsHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "Finance" ? 
                                financeHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "Warranty" ? 
                                warrantyHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            type === "Others" ? 
                                othersHeaders.map((headCell) => (
                                    <TableCell className={headCell.classLabel}
                                        key={headCell.id}
                                    >
                                        {headCell.label}
                                    </TableCell>
                                )) 
                            :
                            ""
                        }
                    </TableRow>
                </TableHead>
                <TableBody className='groupComparisonTableBody'>
                    { 
                        sites && sites.length > 0 && sites.sort((a, b) => {
                            if (a.site === "GROUP") return -1;
                            if (b.site === "GROUP") return 1;
                            return a.site.localeCompare(b.site);
                        }).map((row) => (
                            type === "Summary" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.newVol}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgNewPPU)}
                                    </TableCell>
                                    <TableCell >
                                        {row.newPPS}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedVol}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgUsedPPU)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedPPS}
                                    </TableCell>
                                </TableRow> 
                            :
                            type === "New" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.newVol}
                                    </TableCell>
                                    <TableCell >
                                        {row.newRetail}
                                    </TableCell>
                                    <TableCell >
                                        {row.newMotability}
                                    </TableCell>
                                    <TableCell >
                                        {row.newFleet}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgNewPPU)}
                                    </TableCell>
                                    <TableCell >
                                        {row.newFinance}
                                    </TableCell>
                                    <TableCell >
                                        {row.newFinancePercent}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newFinanceCommission)}
                                    </TableCell>
                                </TableRow> 
                            :
                            type === "Used" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedVol}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedRetail}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.avgUsedPPU)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedMechPrep)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedBodyWork)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedFinance}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedFinancePercent}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedFinanceCommission)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedTrade}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedTradePPU)}
                                    </TableCell>
                                </TableRow>
                            :
                            type === "NewProducts" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.newPPS}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newProductProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {row.newProductPercent}
                                    </TableCell>
                                    <TableCell >
                                        {row.newSupagard + " (" + row.newSupagardPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.newServicePlan + " (" + row.newServicePlanPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.newTyreAndAlloy + " (" + row.newTyreAndAlloyPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.newCosmetic + " (" + row.newCosmeticPercent + ")"}
                                    </TableCell>
                                </TableRow>
                            :
                            type === "UsedProducts" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedPPS}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedProductProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedProductPercent}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedSupagard + " ("+ row.usedSupagardPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedServicePlan + " ("+ row.usedServicePlanPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedTyreAndAlloy + " ("+ row.usedTyreAndAlloyPercent + ")"}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedCosmetic + " ("+ row.usedCosmeticPercent + ")"}
                                    </TableCell>
                                </TableRow>
                            :
                             type === "Finance" ? <>
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        <div className='financeModalWrp'>
                                            <span onClick={(e) => handleFinanceModal(e, row.site)}><AddCircleOutlined /></span> {row.site}
                                        </div>
                                    </TableCell>
                                    <TableCell >
                                        {row.newFinance}
                                    </TableCell>
                                    <TableCell >
                                        {row.newFinancePercent}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newFinanceVol)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newFinanceCommission)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedFinance}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedFinancePercent}
                                    </TableCell> 
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedFinanceVol)}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedFinanceCommission)}
                                    </TableCell>
                                </TableRow>
                                <TableRow className="dropdownRow">
                                    <TableCell colSpan={7} style={{ padding: 0, borderBottom: 0 }}>
                                        <div
                                            className="financeTableModal"
                                            id={"financeModal-"+row.site}
                                        >
                                            <Typography variant="h6" gutterBottom component="div" style={{ margin: "0px 0 10px" }}>
                                                New
                                            </Typography>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                    <TableCell>Company</TableCell>
                                                    <TableCell>Cases</TableCell>
                                                    <TableCell>Total Vol</TableCell>
                                                    <TableCell>Commission</TableCell>
                                                    <TableCell>Pen</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {
                                                    row.newFinanceCompanies.map((fin, i) => (
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>{fin.companyName}</TableCell>
                                                                <TableCell>{fin.cases}</TableCell>
                                                                <TableCell>{formatters.CurrencyThousandSeparatorWithoutZero(fin.volume)}</TableCell>
                                                                <TableCell>{formatters.CurrencyThousandSeparatorWithoutZero(fin.commission)}</TableCell>
                                                                <TableCell>{fin.pen}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    ))
                                                }
                                                
                                            </Table>
                                            <Typography variant="h6" gutterBottom component="div" style={{ margin: "20px 0 10px" }}>
                                                Used
                                            </Typography>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                    <TableCell>Company</TableCell>
                                                    <TableCell>Cases</TableCell>
                                                    <TableCell>Total Vol</TableCell>
                                                    <TableCell>Commission</TableCell>
                                                    <TableCell>Pen</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {
                                                    row.usedFinanceCompanies.map((fin, i) => (
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>{fin.companyName}</TableCell>
                                                                <TableCell>{fin.cases}</TableCell>
                                                                <TableCell>{formatters.CurrencyThousandSeparatorWithoutZero(fin.volume)}</TableCell>
                                                                <TableCell>{formatters.CurrencyThousandSeparatorWithoutZero(fin.commission)}</TableCell>
                                                                <TableCell>{fin.pen}</TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    ))
                                                }
                                                
                                            </Table>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </>
                            :
                             type === "Warranty" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {row.warrantyVol}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.warrantyProfit)}
                                    </TableCell>
                                     <TableCell >
                                        {Math.round((row.warrantyVol * 100) / row.usedRetail) + "%"}
                                    </TableCell>
                                    <TableCell >
                                        {row.ccPremium}
                                    </TableCell>
                                    <TableCell >
                                        {row.ccPremiumPlus}
                                    </TableCell>
                                     <TableCell >
                                        {row.nicEx}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.missedUpsell)}
                                    </TableCell>
                                </TableRow>
                            :
                            type === "Others" ?
                                <TableRow className="groupComparisonTableRow">
                                    <TableCell className='columnSize180'>
                                        {row.site}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.newAccProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {row.newDeliveryPack}
                                    </TableCell>
                                     <TableCell >
                                        {row.newIncorrectAdmin}
                                    </TableCell>
                                     <TableCell >
                                        {row.newIncorrectFuel}
                                    </TableCell>
                                    <TableCell >
                                        {formatters.CurrencyThousandSeparatorWithoutZero(row.usedAccProfit)}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedDeliveryPack}
                                    </TableCell>
                                     <TableCell >
                                        {row.usedIncorrectAdmin}
                                    </TableCell>
                                    <TableCell >
                                        {row.usedIncorrectFuel}
                                    </TableCell>
                                    <TableCell >
                                        {row.tradeIncorrectAdmin}
                                    </TableCell>
                                </TableRow>
                            :
                            ""
                        )) 
                    }                     
                </TableBody>
            </Table>
        </TableContainer>
    );
}